import { render, staticRenderFns } from "./Convenciones.vue?vue&type=template&id=e5b45052&scoped=true"
import script from "./Convenciones.vue?vue&type=script&lang=js"
export * from "./Convenciones.vue?vue&type=script&lang=js"
import style0 from "./Convenciones.vue?vue&type=style&index=0&id=e5b45052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b45052",
  null
  
)

export default component.exports